import GrowingPatterns from "../../components/ClassTwo/NumberMath/GrowingPatterns";
import PatternComponent from "../../components/ClassTwo/NumberMath/RepeatingPatterns";
import SkipCounting from "../../components/ClassTwo/NumberMath/SkipCounting";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/patterns-repeating", title: "Easy", component: PatternComponent },
    { url: "/class-two/number-math/patterns-skip-counting", title: "Medium", component: SkipCounting },
    { url: "/class-two/number-math/patterns-growing", title: "Hard", component: GrowingPatterns }
];

export default topics;